import React from 'react';
import { getGroupActionNeededList } from 'api/credentialing';
import type { TProviderActionGroup } from 'types/credentialing';

let globalData: TProviderActionGroup[] = [];

const useGroupActionNeeded = (enabled = true): [TProviderActionGroup[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TProviderActionGroup[]>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getGroupActionNeededList();
            if (!result.error) {
                const list: TProviderActionGroup[] = result?.data?.data || [];
                globalData = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        if (enabled) fetchData();
    }, [fetchData, enabled]);

    return [data, loading, fetchData];
};

export default useGroupActionNeeded;
